/**
 * Formats the file size in human-readable format.
 *
 * @param bytes The size of the file in bytes.
 * @param decimalPoint The number of decimal points to include in the formatted size. Default is 2.
 * @returns The formatted file size in human-readable format.
 */
export function formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes == 0) {
        return '0 Bytes';
    }

    const base = 1024;
    const dm = decimalPoint || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
    const exponent = Math.floor(Math.log(bytes) / Math.log(base));

    return (
        parseFloat((bytes / Math.pow(base, exponent)).toFixed(dm)) +
        ' ' +
        sizes[exponent]
    );
}
